import * as sagaEffects from 'redux-saga/effects';
import { getFirebase } from 'react-redux-firebase';

import types from '../actionTypes';

const { takeEvery, call } = sagaEffects;

function* handler() {
    const firebase = getFirebase();
    yield call([firebase.auth(), firebase.auth().signOut]);
}

export default function* () {
    yield takeEvery(types.LOGOUT_REQUEST, handler);
}
